import { AlertTriangle } from "lucide-react";
import { DASHBOARD_LABELS } from "../messages";

export function CronFailureAlert(): JSX.Element {
  return (
    <div
      role="alert"
      className="flex w-full items-start gap-3 rounded-lg border border-red-300 bg-red-50 px-4 py-3"
    >
      <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-red-600" />
      <div>
        <p className="text-sm font-semibold text-red-900">
          {DASHBOARD_LABELS.CRON_FAILURE_TITLE}
        </p>
        <p className="text-xs text-red-800">
          {DASHBOARD_LABELS.CRON_FAILURE_DESCRIPTION}
        </p>
      </div>
    </div>
  );
}
